import React from 'react';
const CustomerContactIcon = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { x: "5.6", y: "2.6", width: "4.8", height: "4.8", rx: "2.4", stroke: "#7D8085", "stroke-width": "1.2" }),
        React.createElement("path", { d: "M2.6 11.5C2.6 10.1745 3.67452 9.1 5 9.1H11C12.3255 9.1 13.4 10.1745 13.4 11.5V13C13.4 13.2209 13.2209 13.4 13 13.4H3C2.77909 13.4 2.6 13.2209 2.6 13V11.5Z", stroke: "#7D8085", "stroke-width": "1.2" })));
};
export default CustomerContactIcon;
